import { log } from '@/utils/common';
import { http } from '../utils/http';

async function getBannerList() {
  try {
    const { data } = await http.get('/banners?brandType=LIFENING');
    log('getBannerList', data);
    return data;
  } catch (e) {
    log('bannerApi::getBannerList', e);
    return {
      error: 'error',
    };
  }
}

async function updateBannerReadCount(bannerId) {
  try {
    log('updateBannerReadCount', bannerId);
    await http.patch(`/banners/${bannerId}/read-count`);
  } catch (e) {
    log('bannerApi::getPopupList', e);
  }
}

async function getPopupList() {
  try {
    const { data } = await http.get('/popup?exposureArea=LIFENING');
    log('getBannerList', data);
    return data;
  } catch (e) {
    log('bannerApi::getPopupList', e);
    return {
      error: 'error',
    };
  }
}

export default {
  getBannerList,
  getPopupList,
  updateBannerReadCount,
};
